// components/WalletPopup.jsx
import React from "react";

const ymd = (val) => {
  if (!val) return "";
  if (typeof val === "string" && /^\d{4}-\d{2}-\d{2}$/.test(val)) return val; // уже строка даты
  const d = new Date(val);
  if (isNaN(d)) return "";
  const local = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 10); // YYYY-MM-DD в локали
};
const fmtDate = (val) => {
  const s = ymd(val);
  if (!s) return "";
  const [y, m, dd] = s.split("-");
  return `${dd}.${m}.${y}`;
};

const Row = ({label, value, bold}) =>
  value ? (
    <div style={{marginBottom: 4}}>
      <strong>{label}</strong> {bold ? <strong>{value}</strong> : value}
    </div>
  ) : null;

export default function WalletPopup({ style, walletDetails, onClose }) {
  const w = walletDetails || {};
  return (
    <div style={{
        position: "fixed", // фиксированное позиционирование относительно viewport
        ...style,
        zIndex: 9999,
        background: "#fff",
        border: "1px solid #ccc",
        borderRadius: "5px",
        padding: "10px",
        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        minWidth: "250px",
        fontSize: "13px",
        whiteSpace: "normal",
        wordBreak: "break-word"
    }}>
      <Row label="Тип:" value={w.type} />
      {["USDT_TRC20","USDT_BEP20"].includes(w.type) && (
        <>
          <Row label="Сеть:" value={w.type === "USDT_TRC20" ? "TRC20" : "BEP20"} />
          <Row label="Адрес:" value={w.usdt_wallet} />
        </>
      )}

      {w.type === "CRYPTO_BOT_CHECK" && (
        <>
          <Row label="Telegram username:" value={w.telegram_user} />
        </>
      )}

      {w.type === "IP_OOO" && (
        <>
          <Row label="№ договора:" value={w.contract_number} />
          <Row label="Дата договора:" value={fmtDate(w.contract_date)} />
          <Row label="Организация/ФИО:" value={w.org_name} />
          <Row label="ИНН:" value={w.inn} />
          <Row label="КПП:" value={w.kpp} />
          <Row label="Счёт:" value={w.account_number} />
          <Row label="БИК:" value={w.bik} />
          <Row label="Банк:" value={w.bank_name} />
        </>
      )}

      {w.type === "SELF_EMPLOYED" && (
        <>
          <Row label="ФИО:" value={w.fio} bold />
          <Row label="ИНН:" value={w.inn} />
          <Row label="Вид деятельности:" value={w.activity_type} />
          <Row label="№ договора:" value={w.contract_number} />
          <Row label="Дата договора:" value={fmtDate(w.contract_date)} />
          <Row label="Р/С:" value={w.account_number} />
          <Row label="БИК:" value={w.bik} />
          <Row label="Имя банка:" value={w.bank_name} />
          <Row label="Номер телефона:" value={w.phone} />
        </>
      )}

      <button
        onClick={onClose}
        style={{marginTop: 8, padding: "6px 10px", border: 0, background: "#0b6cff", color:"#fff", borderRadius:6}}
      >
        Закрыть
      </button>
    </div>
  );
}
